import { defineStore } from "pinia";
import { getMacRelease } from "@/services/api/tokenomics";

export const useReleaseStore = defineStore("release", {
  state: () => ({
    macRelease: null,
  }),
  actions: {
    async loadMacRelease() {
      try {
        this.macRelease = await getMacRelease();
      } catch {
        this.macRelease = null;
      }
      return this.macRelease;
    },
  },
});
